import React from 'react'

import CTA from '@f/elements/CTA'

const FilterFeature = props => {
  return (
    <div className='[ f-m-b-020 ]'>
      {typeof props.feature.target === 'string' ? (
        <CTA
          tag='a'
          type='text-primary'
          className='[ f-t-body ]'
          href={props.feature.target}
          wtData={props.feature.wtData}>
          {props.feature.label}
        </CTA>
      ) : (
        <CTA
          tag='button'
          type='text-primary'
          className='[ f-t-body ]'
          onClick={props.feature.target}
          wtData={props.feature.wtData}>
          {props.feature.label}
        </CTA>
      )}
    </div>
  )
}

export default FilterFeature
